export const GET_PENDINGUSERS_SUCCESS = "GET_PENDINGUSERS_SUCCESS";
export const UPDATE_PENDINGUSER_SUCCESS = "UPDATE_PENDINGUSER_SUCCESS";
export const ADD_PENDINGUSER_SUCCESS = "ADD_PENDINGUSER_SUCCESS";
export const DELETE_PENDINGUSER_SUCCESS = "DELETE_PENDINGUSER_SUCCESS";
export const CLEAR_PENDINGUSER_LISTING_SUCCESS = "CLEAR_PENDINGUSER_LISTING_SUCCESS";
// | clearPendingUserListingSuccessAction;
